import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { envUrl } from '../app/services/environment/EnvironmentService';
import AccessoriesPage from '../app/accessories/AccessoriesPageContainer';
import AccessoryPage from '../app/accessories/accessory/AccessoryPageContainer';

const componentMap = {
  AccessoriesPage,
  AccessoryPage,
};

const AccessoriesRoutes = ({ componentMapOverride }) => {
  const pages = componentMapOverride ? componentMapOverride(componentMap) : componentMap;

  return (
    <Switch>
      <Route exact path={envUrl('/accessories')}>
        <Redirect to={envUrl('/accessories/all-moo-products')} />
      </Route>

      <Route exact path={envUrl('/accessories/:type')} component={pages.AccessoriesPage} />
      <Route exact path={envUrl('/accessories/:type/:name')} component={pages.AccessoryPage} />
    </Switch>
  );
};

export default AccessoriesRoutes;
